module.exports = __webpack_public_path__ + "svgs/arrow_right.3c9efe879e86f964458adf852dfdbd85.svg";